import studentDto from 'grpc-bob/student_pb'
import {StudentClient, getMetadata} from './base';

import {getStudentIdFromToken} from '../utils';

const StudentService = {
  async getStudentByToken(token: string) {
    let userId = getStudentIdFromToken(token);

    if (!userId) throw new Error('cannotParseToken');

    const req = new studentDto.GetStudentProfileRequest();
    req.setStudentIdsList([userId!]);

    const resp = await StudentClient.getStudentProfile(req, getMetadata(token));

    return resp.toObject().datasList[0]
  }
};

export default StudentService
